/* KL CARD-TRIAD item 2 (Brent 2026-08-21, HOD consult ruling): the shared
   View Design Closeup modal for product cards and the Quick Buy drawer.
   ONE modal per page, built on first use and fed the clicked button's
   data-closeup-src — never one modal per card. Interaction is the PDP's
   B4-family zoom verbatim: click zooms anchored at the click point capped
   at native resolution, drag pans, click again unzooms, backdrop or X
   closes. Document-level delegation throughout (house rule since C+F:
   the Quick Buy drawer arrives after load, and cached node refs die).
   z-index sits above the side panel (90) so the modal layers over an open
   drawer; closing the modal never touches the drawer or its scroll lock.
   Loaded once from theme.liquid, deferred; self-guarded; no-ops on pages
   with no closeup buttons. */
(function () {
  if (window.KLCardCloseup) return;
  window.KLCardCloseup = true;
  var ZOOM_OUT_LABEL = (document.currentScript && document.currentScript.dataset.zoomOutLabel) || 'Zoom out';

  var zoom = null, scroller = null, img = null, drag = null, moved = false, suppressClick = false;

  function build() {
    zoom = document.createElement('div');
    zoom.className = 'kl-card-zoom';
    zoom.hidden = true;
    zoom.innerHTML =
      '<div class="kl-card-zoom__card">' +
        '<button type="button" class="kl-card-zoom__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<button type="button" class="kl-card-zoom__out" hidden>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><path d="M8 11h6"/></svg>' +
        '</button>' +
        '<div class="kl-card-zoom__scroll" data-kl-card-zoomscroll>' +
          '<img class="kl-card-zoom__img" alt="">' +
        '</div>' +
      '</div>';
    zoom.querySelector('.kl-card-zoom__out').setAttribute('aria-label', ZOOM_OUT_LABEL);
    document.body.appendChild(zoom);
    scroller = zoom.querySelector('[data-kl-card-zoomscroll]');
    img = zoom.querySelector('.kl-card-zoom__img');

    scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
    scroller.addEventListener('pointerdown', function (e) {
      if (!img.classList.contains('kl-card-zoom__img--zoomed')) return;
      e.preventDefault();
      drag = { x: e.clientX, y: e.clientY, left: scroller.scrollLeft, top: scroller.scrollTop };
      moved = false;
      scroller.classList.add('kl-card-zoom__scroll--dragging');
      scroller.setPointerCapture(e.pointerId);
    });
    scroller.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) moved = true;
      scroller.scrollLeft = drag.left - dx;
      scroller.scrollTop = drag.top - dy;
    });
    /* Brent fix 2026-08-22 (+ HOD touch round): while zoomed, a MOUSE
       pointerdown's preventDefault suppresses the browser click, so the
       old click-to-unzoom was unreachable — the tap is detected on
       pointerup instead: released without dragging = zoom back out. On
       TOUCH the browser still delivers a click AFTER our tap-unzoom
       (preventDefault does not suppress touch-derived clicks), and that
       click re-zoomed — so the one click following a tap-unzoom is
       swallowed. pointercancel means the browser took the gesture as a
       native scroll (a PAN, never a tap) — it must not unzoom. */
    var endDrag = function () {
      drag = null;
      scroller.classList.remove('kl-card-zoom__scroll--dragging');
    };
    scroller.addEventListener('pointerup', function () {
      var wasDrag = !!drag;
      endDrag();
      if (wasDrag && !moved && img.classList.contains('kl-card-zoom__img--zoomed')) {
        unzoom();
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 500);
      }
    });
    scroller.addEventListener('pointercancel', endDrag);
  }

  function zoomWidth() {
    var fit = scroller.clientWidth;
    var native = img.naturalWidth / Math.min(window.devicePixelRatio || 1, 2);
    return Math.min(fit * 2, native);
  }
  function canZoom() { return img && img.naturalWidth > 0 && zoomWidth() > scroller.clientWidth * 1.05; }
  function unzoom() {
    img.style.width = '';
    img.classList.remove('kl-card-zoom__img--zoomed');
    var out = zoom && zoom.querySelector('.kl-card-zoom__out');
    if (out) out.hidden = true;
  }
  function zoomAt(clientX, clientY) {
    var r = img.getBoundingClientRect();
    var relX = (clientX - r.left) / r.width;
    var relY = (clientY - r.top) / r.height;
    var w = zoomWidth();
    var h = w * (img.naturalHeight / img.naturalWidth);
    var sr = scroller.getBoundingClientRect();
    img.style.width = w + 'px';
    img.classList.add('kl-card-zoom__img--zoomed');
    scroller.scrollLeft = relX * w - (clientX - sr.left);
    scroller.scrollTop = relY * h - (clientY - sr.top);
    var out = zoom.querySelector('.kl-card-zoom__out');
    if (out) out.hidden = false;
  }
  /* Phase 7 (Brent: the close-up takes too long to open): warm the picture
     the moment the pointer reaches the button, so the click finds it cached. */
  var warmed = {};
  function warm(btn) {
    var src = btn.getAttribute('data-closeup-src');
    if (!src || warmed[src]) return;
    warmed[src] = true;
    var pre = new Image(); pre.decoding = 'async'; pre.src = src;
  }
  document.addEventListener('pointerenter', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-kl-card-closeup]');
    if (btn) warm(btn);
  }, true);
  function open(btn) {
    if (!zoom) build();
    var src = btn.getAttribute('data-closeup-src');
    if (!src) return;
    if (img.getAttribute('src') !== src) {
      /* cold load of the 2400px file: show the spinner until it lands so
         the modal never sits as a blank white card */
      zoom.classList.add('kl-card-zoom--loading');
      img.addEventListener('load', function done() {
        img.removeEventListener('load', done);
        zoom.classList.remove('kl-card-zoom--loading');
      });
      img.setAttribute('src', src);
    }
    if (img.complete && img.naturalWidth > 0) zoom.classList.remove('kl-card-zoom--loading');
    img.setAttribute('alt', btn.getAttribute('data-closeup-alt') || '');
    unzoom();
    zoom.hidden = false;
    document.body.classList.add('overflow-hidden');   // mobile audit 4 Oct 2026 F2: hold the page still, as the theme's modal-dialog does
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kl-card-closeup]');
    if (btn) { e.preventDefault(); open(btn); return; }
    if (!zoom || zoom.hidden) return;
    if (e.target.closest('.kl-card-zoom__out')) { unzoom(); return; }
    if (suppressClick) { suppressClick = false; return; }
    if (moved) { moved = false; return; }
    var hitImg = e.target.closest('.kl-card-zoom__img');
    if (hitImg) {
      if (hitImg.classList.contains('kl-card-zoom__img--zoomed')) unzoom();
      else if (canZoom()) zoomAt(e.clientX, e.clientY);
      return;
    }
    if (e.target === zoom || e.target.closest('.kl-card-zoom__close')) {
      zoom.hidden = true;
      document.body.classList.remove('overflow-hidden');
      unzoom();
    }
  });

  /* Escape must close ONLY the modal, never the Quick Buy drawer beneath
     it (HOD push-review defect 1; comment corrected per fix-round note
     2). The theme closes the drawer from document-bubble KEYUP handlers
     — so the KEYUP SWALLOW below is the load-bearing half of this guard:
     the keydown listener closes the modal and arms the swallow, and the
     window-capture keyup then kills the event before the theme's
     document-bubble closers see it. Both register at script load and are
     gated on modal visibility — HOD-proven inert when no modal is open
     (the drawer's own Escape behaviour is untouched). */
  var escKeyupSwallow = false;
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !zoom || zoom.hidden) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    escKeyupSwallow = true;
    zoom.hidden = true;
    document.body.classList.remove('overflow-hidden');
    unzoom();
  }, true);
  window.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && escKeyupSwallow) {
      escKeyupSwallow = false;
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
})();
